import { styled } from '@mui/system'
import { Stack, Typography } from '@mui/material'

export const CardTitleContainer = styled(Stack)`
  padding-top: 12px;
  padding-bottom: 5px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const CardTitleText = styled(Typography)`
  font-size: 20px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.text.secondary};
`
